import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { AngularFire} from 'angularfire2'
import * as firebase from 'firebase';

//declare var firebase;
/*
  Generated class for the FirebaseStorageProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class FirebaseStorageProvider {

    constructor(
        public http: Http,
        public af2:AngularFire
    ) {
        
    }
    ngUpLoad() {
        console.log('Hello FirebaseStorageProvider Provider');
        var storageRef = firebase.storage().ref();
        var ref = storageRef.child('images/mountains.txt');
        // Raw string is the default if no format is provided
        var message = 'This is my message.';
        ref.putString(message).then(function (snapshot) {
            console.log('Uploaded a raw string!');
        });

        // Base64 formatted string
        var message = '5b6p5Y+344GX44G+44GX44Gf77yB44GK44KB44Gn44Go44GG77yB';
        ref.putString(message, 'base64').then(function (snapshot) {
            console.log('Uploaded a base64 string!');
        });

        // Base64url formatted string
        var message = '5b6p5Y-344GX44G-44GX44Gf77yB44GK44KB44Gn44Go44GG77yB';
        ref.putString(message, 'base64url').then(function (snapshot) {
            console.log('Uploaded a base64url string!');
        });
    }

}



// WEBPACK FOOTER //
// ./src/providers/firebase-storage-provider.ts